// src/pages/Privacy.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/theme.css';
import '../styles/Dashboard.css';

export default function Privacy() {
  return (
    <main className="dashboard-fade-in">
      <Header />
      <div className="container page">
        <header className="dash-head">
          <h1>Privacy Policy</h1>
          <p className="meta">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </header>

        <section className="card">
          <h2>Introduction</h2>
          <p>
            Your Highest Self ("we", "us", or "our") respects your privacy and is committed to protecting your personal data.
            This privacy policy explains how we collect, use, and safeguard your information when you use our service.
          </p>
        </section>

        <section className="card">
          <h2>Information We Collect</h2>
          <p>We collect and process the following types of information:</p>
          <ul className="list">
            <li><b>Phone Number:</b> Used for authentication and to deliver daily SMS messages</li>
            <li><b>Birth Information:</b> Optional birth date, time, and location for personalized content</li>
            <li><b>Timezone Preference:</b> To deliver messages at the appropriate time</li>
            <li><b>Payment Information:</b> Processed securely through Stripe (we do not store credit card details)</li>
            <li><b>Usage Data:</b> Basic service interaction data for improving our offering</li>
          </ul>
        </section>

        <section className="card">
          <h2>How We Use Your Information</h2>
          <p>Your information is used to:</p>
          <ul className="list">
            <li>Authenticate your account and provide access to the service</li>
            <li>Send daily SMS messages with personalized spiritual content</li>
            <li>Process subscription payments and manage billing</li>
            <li>Improve and personalize your experience</li>
            <li>Communicate important service updates</li>
          </ul>
        </section>

        <section className="card">
          <h2>Data Sharing and Third Parties</h2>
          <p>
            We do not sell your personal information. We share data only with essential service providers:
          </p>
          <ul className="list">
            <li><b>AWS (Amazon Web Services):</b> Cloud infrastructure and data storage</li>
            <li><b>Stripe:</b> Payment processing</li>
            <li><b>SMS Service Provider:</b> Message delivery</li>
          </ul>
          <p>These partners are contractually obligated to protect your data and use it only for specified purposes.</p>
        </section>

        <section className="card">
          <h2>Data Security</h2>
          <p>
            We implement industry-standard security measures including encryption, secure authentication,
            and access controls to protect your information from unauthorized access, alteration, or disclosure.
          </p>
        </section>

        <section className="card">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul className="list">
            <li>Access your personal data</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your data</li>
            <li>Opt out of communications (cancel subscription)</li>
            <li>Export your data</li>
          </ul>
        </section>

        <section className="card">
          <h2>Data Retention</h2>
          <p>
            We retain your personal information for as long as your account is active or as needed to provide services.
            If you cancel your subscription, we may retain certain data for legal, tax, or operational purposes.
          </p>
        </section>

        <section className="card">
          <h2>Changes to This Policy</h2>
          <p>
            We may update this privacy policy from time to time. We will notify you of significant changes
            via email or through the service.
          </p>
        </section>

        <section className="card">
          <h2>Contact Us</h2>
          <p>
            If you have questions about this privacy policy or how we handle your data, please contact us.
          </p>
          <div className="row row--start" style={{ marginTop: '1rem' }}>
            <Link to="/" className="btn btn--ghost">
              Back to Home
            </Link>
          </div>
        </section>
      </div>
      <Footer />
    </main>
  );
}
